var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{model:{value:(_vm.model.title),callback:function ($$v) {_vm.$set(_vm.model, "title", $$v)},expression:"model.title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }